import { Box, Flex, Text, Button, Heading, Grid, Card } from '@radix-ui/themes';
import { PersonIcon } from '@radix-ui/react-icons';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import CreateCourseDialog from '../forms/CreateCourseDialog';
import { Link } from 'react-router-dom';
import ContentCreator from '../forms/teacher/ContentCreator';
import TeacherCompletions from '../teacher/TeacherCompletions';

const TeacherDashboard = () => {
  const user = useSelector((state) => state.user.details);
  console.log('Teacher dashboard user', user);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box width="100%" height="100%" align="start">
      {/* <Heading size="5" weight="bold" mb="4" align="start">Dashboard</Heading> */}
      <Grid
        columns={{ initial: '1', sm: '2' }}
        rows="auto"
        gapX="4"
        gapY="2"
      >
        <Box style={{
          gridColumn: { initial: '1', sm: '1' }
        }}>
          <ContentCreator draft={null} />
        </Box>
        <Card style={{
          gridColumn: { initial: '1', sm: '2' }
        }}>
          <TeacherCompletions />
        </Card>
      </Grid>
    </Box>
  );
};

export default TeacherDashboard;